import React, { useEffect, useState } from 'react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// components

// custom functions

// styles
import styles from './index.module.scss'

import SeeMoreButton from 'components/Button/SeeMoreButton'
import OutlineButton from 'components/Button/OutlineButton'
import MerchShopCard from 'components/Card/MerchShopCard'
import { getTimeDifference } from 'utils/helpers'

// call apis
import StoreAPI from 'apis/store'
import router from 'next/router'
import { useViewport } from 'utils'

const HomeStudioReleaseSection = props => {
  const { onLoaded } = props
  const viewport = useViewport()

  const [merchList, setMerchList] = useState([])
  const [selectedType, setSelectedType] = useState({ id: -1, name: 'All' })
  const apparelTypes = [
    { id: -1, name: 'All' },
    {
      id: 0,
      name: 'Tees',
    },
    {
      id: 2,
      name: 'Hoodies',
    },
    {
      id: 4,
      name: 'Sweatshirts',
    },
    {
      id: 7,
      name: 'Jackets',
    },
    {
      id: 8,
      name: 'Crop Tops',
    },
    {
      id: 3,
      name: 'Long Sleeves',
    },
    {
      id: 10,
      name: 'Hats',
    },
    {
      id: 1,
      name: 'Polos',
    },
  ]

  useEffect(() => {
    getStoreItem({ id: -1, name: 'All' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getFilterData = response => {
    let list = response.filter(
      item =>
        item.master_edition_address !== '' &&
        (item.sale_end_at === null || getTimeDifference(item.sale_end_at) > 0) &&
        (item.supply === null || item.supply - item.current_supply > 0)
    )

    return list
  }

  const getStoreItem = apparelType => {
    let typeIds = []
    if (apparelType.id === 0) {
      typeIds.push(5, 6, 9, 10, 22, 23)
    } else if (apparelType.id === 1) {
      typeIds.push(25, 26)
    } else if (apparelType.id === 2) {
      typeIds.push(1, 2, 31, 32, 33, 36, 37, 49, 50)
    } else if (apparelType.id === 3) {
      typeIds.push(3, 4, 47, 48)
    } else if (apparelType.id === 4) {
      typeIds.push(7, 8, 38, 39)
    } else if (apparelType.id === 5) {
      typeIds.push(9, 10)
    } else if (apparelType.id === 6) {
      typeIds.push(34, 35)
    } else if (apparelType.id === 7) {
      typeIds.push(27, 28, 29, 30)
    } else if (apparelType.id === 8) {
      typeIds.push(36, 37, 38, 39)
    } else if (apparelType.id === 9) {
      typeIds.push(12)
    } else if (apparelType.id === 10) {
      typeIds.push(16, 40, 41, 51)
    }

    let params = {
      sort: 'latest',
      category: 'standalone',
    }

    if (typeIds.length > 0) {
      params['typeIds'] = typeIds
    }

    StoreAPI.getStoreFeeds(1, 20, params).then(
      response => {
        let result = response.products
        let filtered = getFilterData(result)
        setMerchList(filtered.splice(0, 10))
        onLoaded()
      },
      error => {
        onLoaded()
      }
    )
  }

  const selectApparelType = item => {
    setSelectedType(item)
    getStoreItem(item)
  }

  return (
    merchList.length !== 0 && (
      <section className={styles.container}>
        <div
          className={`${
            viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? '' : 'g-container'
          } px-[16px] relative w-full flex justify-between items-center z-101`}
        >
          <div className={`${styles.title}`}>Recently Listed</div>
          <div className="">
            <SeeMoreButton
              label="View All"
              onClick={() => {
                router.push('/studio/merch')
              }}
            />
          </div>
        </div>

        <div
          className={`${
            viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? '' : 'g-container'
          } flex lg:ml-[0px] pl-[16px] pr-[16px] gap-[12px] overflow-x-scroll mt-[15px] lg:mt-[25px] lg:pb-[15px]`}
        >
          {apparelTypes.map(item => (
            <div
              key={item.id}
              className={`${selectedType.id === item.id ? styles.selectedBtn : styles.unselectedBtn}`}
              onClick={() => selectApparelType(item)}
            >
              {item.name}
            </div>
          ))}
        </div>

        <div
          className={`${
            viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? '' : 'g-container'
          } px-[16px] w-full grid xs:grid-cols-20 gap-[18px] md:gap-[22px] lg:gap-[22px] mt-[15px] lg:mt-[25px] z-10`}
        >
          {merchList.map((item, index) => (
            <div className="xs:col-span-10 lg:col-span-5 2xl:col-span-4" key={item.id}>
              <MerchShopCard username={item.username} data={item} />
            </div>
          ))}
        </div>

        {/* <div className="w-full flex sm:hidden justify-center lg:mt-0 mt-[25px]">
          <div className="w-full max-w-[300px] z-10">
            <OutlineButton
              label="See More"
              fullWidth
              onClick={() => {
                router.push('/studio/merch')
              }}
              fontSize="16px"
              height="41px"
              borderRadius="8px"
            />
          </div>
        </div> */}
      </section>
    )
  )
}

export default HomeStudioReleaseSection
